export const TeamMembers = ({ tasks }) => {
    const pics = new Set(tasks.map(t => t?.pic).filter(Boolean));
    const teamArray = Array.from(pics);
    if (teamArray.length === 0) return null;
    return (
        <>
        <div style={{ width: '1px', height: '40px', background: '#e2e8f0' }} />
        <div>
            <div style={{ fontSize: '11px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '6px' }}>Team Members</div>
            <div style={{ display: 'flex', gap: '-6px' }}>
            {teamArray.slice(0, 5).map((nameRaw, i) => {
                const name = String(nameRaw);
                const parts = name.split('-');
                const nik = parts.length > 1 ? parts[0] : null;
                const displayName = parts.length > 1 ? parts[1] : name;

                return (
                    <div
                        key={name}
                        title={displayName}
                        style={{
                            width: '40px', height: '40px', borderRadius: '50%',
                            background: `hsl(${(name.length * 40) % 360}, 70%, 50%)`, // deterministic random color
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '11px', fontWeight: '700', color: '#fff',
                            border: '2px solid #fff',
                            marginLeft: i > 0 ? '-8px' : 0,
                            boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                            zIndex: 10 - i,
                            cursor: 'default',
                            transition: 'transform 0.2s, z-index 0.2s',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-3px) scale(2.7)';
                            e.currentTarget.style.zIndex = 99;
                            const img = e.currentTarget.querySelector('img');
                            if (img) img.style.transform = 'scale(1.8)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'none';
                            e.currentTarget.style.zIndex = 10 - i;
                            const img = e.currentTarget.querySelector('img');
                            if (img) img.style.transform = 'scale(1)';
                        }}
                    >
                        {displayName.substring(0, 2).toUpperCase()}
                        {nik && (
                            <img
                                src={`https://hrisgelora.co.id/upload/avatar/foto_karyawan/${displayName} - ${nik}.JPG`}
                                alt={displayName}
                                loading="lazy"
                                onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                        )}
                    </div>
                )
            })}
            {teamArray.length > 5 && (
                <div style={{
                    width: '34px', height: '34px', borderRadius: '50%', background: '#e2e8f0',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '700', color: '#64748b',
                    border: '2px solid #fff', marginLeft: '-8px', zIndex: 1
                }}>
                    +{teamArray.length - 5}
                </div>
            )}
            </div>
        </div>
        </>
    );
};